import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { Field, useFormikContext } from "formik";
import classnames from "classnames";
import {
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as fontAwesome from "@fortawesome/free-solid-svg-icons";

const TextField = (props) => {
  const [focusedField, setFocusedField] = useState(false);
  const { isSubmitting, setFieldValue } = useFormikContext();

  return (
    <FormGroup
      className={classnames({
        focused: focusedField,
      })}
    >
      <InputGroup className="input-group-merge input-group-alternative">
        <InputGroupAddon addonType="prepend">
          <InputGroupText>
            {props.fontAwesome ? (
              <FontAwesomeIcon icon={fontAwesome[props.fontAwesome]} />
            ) : (
              <i className={props.icon} />
            )}
          </InputGroupText>
        </InputGroupAddon>
        <FormattedMessage id={"fields." + props.name}>
          {(placeholder) => (
            <Field
              name={props.name}
              type="text"
              className="form-control"
              placeholder={
                `${placeholder}` + (props.required === true ? " *" : "")
              }
              onFocus={() => {
                if (props.focusEffect) setFocusedField(true);
              }}
              onBlur={(e) => {
                props.handleBlur(e);

                if (props.focusEffect) setFocusedField(true);
              }}
              autoComplete={props.autoComplete}
              onChange={(event) => {
                setFieldValue(props.name, event.target.value);
                if (props.onChange) props.onChange(event);
              }}
              id={props.id}
              disabled={isSubmitting}
            />
          )}
        </FormattedMessage>
      </InputGroup>
    </FormGroup>
  );
};

TextField.defaultProps = {
  name: "firstName",
  icon: "ni ni-single-02",
  autoComplete: "on",
  focusEffect: true,
  fontAwesome: "",
  value: "",
};

export { TextField };
